import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import React from 'react';
import { compose } from 'recompose';
import withNotifications from '../../../../common/withNotifications';

import config from '../../../../../config';
import { openAppointmentFormWithDateTime } from '../../../../common/helpers/fullCalendar';
import withNextAvailableTime from '../../../../common/hoc/withNextAvailableTime';
import { t } from '../../../../../modules/infra/i18n';

const NextAvailableTime = ({ barberId, timezone, duration, fetchNextAvailableTime, addNotification }) => {
  const onClick = async () => {
    const nextAvailableTime = await fetchNextAvailableTime(barberId, duration, timezone);
    if (!nextAvailableTime) {
      addNotification({
        title: t('appointment:side_by_side.no_available_times'),
        level: 'error',
        message: t('appointment:side_by_side.no_available_times_message'),
      });

      return false;
    }
    const data = {
      barberId,
      day: moment.tz(nextAvailableTime, timezone).format(config.dateFormatISO),
      time: moment.tz(nextAvailableTime, timezone).format('HH:mm'),
    };

    return openAppointmentFormWithDateTime(data);
  };
  return (
    <a
      data-automation-id={`hoverMenu:nextAvailableTime:${barberId}`}
      className="u-block c-btn c-btn--outline c-btn--outline-grey c-btn--small"
      onClick={onClick}
    >
      {t('appointment:side_by_side.next_available_time')}
    </a>
  );
};
NextAvailableTime.propTypes = {
  barberId: PropTypes.string.isRequired,
  timezone: PropTypes.string.isRequired,
  duration: PropTypes.number.isRequired,
  fetchNextAvailableTime: PropTypes.func.isRequired,
  addNotification: PropTypes.func.isRequired,
};

export default compose(
  withNextAvailableTime,
  withNotifications
)(NextAvailableTime);
